import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder,  UntypedFormGroup, Validators } from '@angular/forms';
import { CrudProductService }  from 'app/_services/MasterCrudOps/crud-product.service';
import { MatDialogRef } from '@angular/material/dialog';
declare const swal: any;

@Component({
  selector: 'app-add-products',
  templateUrl: './add-products.component.html'
  
})
export class AddProductsComponent implements OnInit {
  addProductForm: UntypedFormGroup;

  constructor( 
    private readonly crudProductService:CrudProductService,
    private readonly dialogRef: MatDialogRef<AddProductsComponent>,
    private readonly formBuilder: UntypedFormBuilder) { }

  ngOnInit() {
    this.initilizeForm();
  }

  initilizeForm() {
     this.addProductForm = this.formBuilder.group({
      productName: [null, [Validators.required, Validators.maxLength(50)]],
      description: [null, [Validators.required, Validators.maxLength(100)]]
    })
  }
  
   
  saveProduct() {
    let errorMessage = '';
    const productName = (this.addProductForm.value.productName ?? '').trim();
    const description = (this.addProductForm.value.description ?? '').trim();
    
  
    if (productName.length > 50) {
      errorMessage = "Product name cannot be more than 50 characters.";
    }
    if (description.length > 100) {
      errorMessage += "\nDescription cannot be more than 100 characters.";
    }
  
    if (errorMessage.length > 0) {
      swal({
        title: '',
        text: errorMessage,
        type: 'error',
        confirmButtonClass: 'btn btn-info'
      });
    } else {
      this.crudProductService.saveProduct(productName, description).subscribe(
        data => {
          swal({
            title: '',
            text: data.message,
            type: data.didError ? 'error' : 'success',
            confirmButtonClass: 'btn btn-info'
          });
          this.dialogRef.close();
        },
        error => {
            let errorMessage =
          error.error?.title ??
          error.error ??
          "Something went wrong. Please contact admin.";

        // Check if it's a validation error response with the `errors` object
        if (error.error?.errors) {
          const allErrors = Object.values(error.error.errors).flat(); // Flatten all error arrays
          if (allErrors.length > 0) {
            errorMessage = allErrors[0]; // Use the first validation message
          }
        } else if (typeof error.error === "string") {
          errorMessage = error.error;
        } else if (error.error?.title) {
          errorMessage = error.error.title;
        }
          swal({
            title: '',
            text: errorMessage,
            type: 'error',
            confirmButtonClass: 'btn btn-info'
          });
        }
      );
    }
  }
  

  close() {
    this.dialogRef.close();
  }
}